module.exports = __webpack_public_path__ + "static/media/comment-bg.98430379.svg";